import React from "react";
import DateRangePicker from "../DateRangePicker/DateRangePicker";
import DatePickerInput from "../DatePickerInput/DatePickerInput";
import GuestSelect from "../GuestSelect/GuestSelect";
import PromoCodeInput from "../PromoCodeInput/PromoCodeInput";
import CurrencySelect from "../Selects/CurrencySelect";

export default class BookingSearchOptions extends React.Component {
  constructor(props) {
    super(props);
  }

  /**
   * Render functions
   */

  render() {
    return (
      <div className="row dates-row" style={{ marginTop: "-15px" }}>
        {this.props.step == 'daily-rentals' ? 
         <div className="flexed DateRangePicker col-md-6">
            <div className="col-sm-6 start-date-wrapper">
              <label style={{ position: "relative", top: "6px", fontSize: "12px" }}>
                {I18n.t('check_in_date')}
              </label>
                <DatePickerInput
                  selectedDate={this.props.start_date || ''}
                  dateFormat={this.props.date_format}
                  onChange={this.props.onChangeStartDate} />
            </div>
          </div>
          : 
          <DateRangePicker
            startDateLabel="check_in_date"
            endDateLabel="check_out_date"
            dateFormat={this.props.date_format}
            onChange={this.props.onChangeDates}
            startDate={this.props.start_date}
            endDate={this.props.end_date}
            minDate={this.props.current_property_date}
            maxDate={this.props.max_booking_date}
            color={this.props.widget_default_color}
            daily={this.props.step == "daily-rentals" ? true : false}
            maxDays={29}
          />
        }
        
        <div className="guest-rate-currency-wrapper">
          {this.props.guest_types.length ? (
            <div className="guest-types">
              <GuestSelect
                guests={this.props.guests}
                guest_types={this.props.guest_types}
                onChange={this.props.onChangeGuestTypeCount}
                onSubmit={this.props.onSubmitGuestTypeCount}
                source="bb"
              />
            </div>
          ) : null}
          <div
            className={
              this.props.guest_types.length
                ? "promo-rates"
                : "promo-rates-no-guest-types promo-rates"
            }
          >
            <PromoCodeInput
              name="promo_code"
              {...this.props}
              value={this.props.promo_code}
              onSubmit={this.props.onSubmitPromoCode}
            />
          </div>
          <div
            className={
              this.props.guest_types.length
                ? "currency"
                : "currency-no-guest-types currency"
            }
          >
            <CurrencySelect
              currency={this.props.currency}
              path={this.props.currencies_list_path}
              onChange={this.props.onChangeCurrency}
            />
          </div>
        </div>
      </div>
    );
  };

};
